import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuService } from './components/menu/menu.service';
import { Location } from '@angular/common';
import { EnviromentGlobalService } from './shared/services/enviroment-global.service';
import { AuthService } from './shared/services/auth.service';
import { IEncuestaResponse } from './shared/models/encuesta.model';
import { first, filter } from 'rxjs/operators';
import { EstablecimientoComercioService } from './components/core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from './shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from './shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEncuestaSatisfaccionComponent } from './shared/layouts/modal-encuesta-satisfaccion/modal-encuesta-satisfaccion.component';
import { ModalAjusteRntComponent } from './components/core/layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';
import { DataSharedService } from './shared/services/data-shared.service';
import { PerfilService } from './components/seguridad/containers/perfil/perfil.service';
import { PrestadorModel } from './shared/models/prestador.model';
import { ModalEditarPerfilComponent } from './components/seguridad/layouts/modal-editar-perfil/modal-editar-perfil.component';
import { UtilService } from './shared/services/util.service';
import { AlertsService } from './shared/services/alerts.service';
import { AlertType } from './shared/models/alert.model';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'RNT-Web';
	KEY_GOOGLE_ANALYTIC;
	prestadorModel: PrestadorModel;
	haveToUpdatePass: boolean = false;
	notValidateChangePassUrl : string[]=["/cambiarContrasena/"];
	// tslint:disable-next-line: max-line-length
	constructor(private router: Router, 
				private menuService: MenuService, 
				private location: Location, 
				private enviromentGlobalService: EnviromentGlobalService,
				private AuthService: AuthService,
				private establecimientoComercioService: EstablecimientoComercioService,
				private modalService: NgbModal,
				private alertService: AlertsService,
				private dataSharedService: DataSharedService,
				private authService : AuthService,
				private perfilService: PerfilService) {

		this.KEY_GOOGLE_ANALYTIC = enviromentGlobalService.idGoogleAnalytic;
		(<any>window).ga('create', this.KEY_GOOGLE_ANALYTIC, 'auto');
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				(<any>window).ga('set', 'page', event.urlAfterRedirects);
				(<any>window).ga('send', 'pageview');
			}
		});
		
		
		this.identificarTieneEncuesta();
	}
	@HostListener('window:beforeunload') beforeunloadHandler() {
		// const ruta_url = this.menuService.getRoles()[0].ruta_url;
		// if (ruta_url) {
		//   this.router.navigate(['home']);
		// } else {
		// 	this.router.navigate(['home']);
		// }
	}
	identificarTieneEncuesta(): void{
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((val: NavigationEnd) => {
			if(this.AuthService.isToken()){
				if(val.url){
					if( this.getTieneEncuestaPendiente() === true){
						this.validarEncuesta(val.url.slice(1));
					}
					if( ! (this.notValidateChangePassUrl.some(x=> val.url.includes(x)) ) ){
						this.validarCambioContrasena();
					}
				}
			}
		});
	}
	getTieneEncuestaPendiente(): boolean {
		try {
			const tieneEncuestaPendiente = JSON.parse(localStorage.getItem('tieneEncuestaPendiente'));
			return tieneEncuestaPendiente as boolean;
		} catch (error) {
			return false;
		}
	}
	
	validarEncuesta(identificadorinterfaz: string): void{
		this.AuthService
			.validarEncuestaSatisfaccion({identificadorinterfaz})
			.subscribe(response=>{
				if(response.data != null){
				let encuestaResponse = response.data as IEncuestaResponse;
				if(encuestaResponse.preguntas.length > 0){
					this.abrirModalDeseaResponderEncuestaDeSatisfaccion(encuestaResponse);
				}
			}
		});
	}
	abrirModalEncuestaSatisfaccion(model: IEncuestaResponse): void{
		
		const modalRef = this.modalService.open(
			ModalEncuestaSatisfaccionComponent,
			{ centered: true, backdrop: "static", size: "lg" }
			);
		modalRef.componentInstance.encuestaModel = model;
	}
	abrirModalDeseaResponderEncuestaDeSatisfaccion(model: IEncuestaResponse): void {
		this.establecimientoComercioService
		  .getParametro({
			parametro_id: "INFO_REALIZAR_ENCUESTA_SATISFACCION",
			agrupacion: "TEXTO",
			auxiliar: "1",
		  })
		  .subscribe((resultado) => {
			if (!resultado?.result) return;
			const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent,
					 { centered: true ,backdrop: "static"});
			const confirmarRespuesta = {} as ConfirmarRespuestaModel;
			confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
			confirmarRespuesta.message = resultado.data;
			modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
			modalRef.result.then(() => {
				this.abrirModalEncuestaSatisfaccion(model);
			}).catch(()=>{
				localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(false));
			});
		  });
	  }
	validarCambioContrasena(): void{
		
		this.authService
			.validarCambioContrasena()
			.subscribe(response=>{
				if(!response.result){
					this.haveToUpdatePass = true;
					this.modalCambioContrasena();
				}
			});
	}
	modalCambioContrasena(): void{
		this.establecimientoComercioService
                .getParametro({
                  parametro_id:
                    "ADVERTENCIA_DEBE_CAMBIAR_CLAVE",
                  agrupacion: "VALIDACIONES",
                  auxiliar: "1",
                })
                .subscribe(
                  (resultado2) => {
                    if (resultado2.result) {
                      const modalCambiarClave = this.modalService.open(
                        ModalAjusteRntComponent,
                        { centered: true, backdrop: "static", size: "md" }
                      );
                      modalCambiarClave.componentInstance.mensaje =
                        resultado2.data;
						modalCambiarClave.result.then(x=>{
							this.openModalChangePassword();
							
					  })
                    }
                  }
                );
	}
	openModalChangePassword() {
		this.perfilService.get(this.authService.getUserNameToken()).subscribe(resultado => {
			if (resultado.result) {
				this.prestadorModel = resultado.data as PrestadorModel;
				this.prestadorModel.usuario = this.authService.getUserNameToken();
				this.onOpenModalProfile();
			}
		});
	}
	modalDebeCambiarClave(): void{
		this.establecimientoComercioService	
			.getParametro({
				parametro_id:
				"MENSAJE_USUARIO_NO_REALIZA_CAMBIO_CLAVE",
				agrupacion: "VALIDACIONES",
				auxiliar: "1",
			}).subscribe(
				(resultado2) => {
				  if (resultado2.result) {
					const modalCambiarClave = this.modalService.open(
                        ModalAjusteRntComponent,
                        { centered: true, backdrop: "static", size: "md" }
                      );
                      modalCambiarClave.componentInstance.mensaje =
                        resultado2.data;
				  }
				}
			);
	}
	onOpenModalProfile() {
		
		const modalRef = this.modalService.open(ModalEditarPerfilComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop',backdrop: "static" });
		modalRef.componentInstance.onlyPassword = true;
		modalRef.componentInstance.prestadorModel = this.prestadorModel;
		modalRef.componentInstance.closeable = false;
		modalRef.result.then(resultado => {
			if (resultado.opc !== 1) {
				this.cambiarContrasena(resultado.data);
			}else{
				this.modalDebeCambiarClave();
			}
		});
		this.getModalState();
	}
	getModalState(): void{
		this.dataSharedService.data$.subscribe(observer=>{
			if(observer != ' '){	
				if(observer.hasOwnProperty('close') && observer.close ){
					if(!this.haveToUpdatePass){
						this.modalService.dismissAll();
					}else{
						this.modalDebeCambiarClave();	
					}
				}
			}
		});
	}
	cambiarContrasena(data: any): void {
		this.perfilService.updateCambiarClave({
			clave_acceso: UtilService.encrypt(data.clave_acceso),
			clave_acceso_anterior: UtilService.encrypt(data.clave_acceso_anterior),
			clave_acceso_confirmacion: UtilService.encrypt(data.clave_acceso_confirmacion),
		}).subscribe(resultado => {
			if (resultado.result) {
				this.haveToUpdatePass= false;
				this.alertService.alert(resultado.control.alert_type as AlertType,
					'contraseña actualizada exitosamente.', '/perfil/', resultado.control.code.toString());
			}
		});
	}
}
